import {useEffect, useState} from "react";
import {useQuery} from "@tanstack/react-query";
import InputSwitch from "../../../../../../components/input/input-switch.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import VmsPlayer from "../../../../../../components/vms-player/vms-player.jsx";
import vmsService, {VMS_QUERY_KEYS} from "../../../../../../services/web/vms-service.js";
import axios from "axios";
import projectUtils from "../../../../../../utils/project-utils.js";

const API_URL = import.meta.env.VITE_API_URL;

const CftvCameraDetails = ({camera, integration, onAssociate, onRemove, onOffsetChange}) => {
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        setOffset(Number(integration?.offset ?? 0));
    }, [camera?.id, camera?.vmsId, integration?.offset]);

    const preview = useQuery({
        queryKey: [...VMS_QUERY_KEYS.cameraPermission(camera?.id, camera?.vmsId)],
        queryFn: () => vmsService.requestCameraPermission(camera.id, camera.vmsId),
        enabled: !!camera,
        retry: false,
    });

    if (!camera) {
        return (
            <div className="flex h-full min-h-0 flex-col">
                <div className="flex h-10 shrink-0 items-center border-b border-gray-300 px-4 font-semibold text-[#676a6c]">Câmera VMS</div>
                <div className="flex flex-1 items-center justify-center p-6 text-center text-sm text-gray-500">Selecione uma câmera VMS no mapa.</div>
            </div>
        );
    }

    const updateOffset = (value) => {
        const parsed = Number(value);
        setOffset(parsed);
        if (integration) onOffsetChange(camera, parsed);
    };

    const toggleAssociation = () => {
        if (integration) {
            onRemove(camera);
            return;
        }

        onAssociate(camera, offset);
    };

    const openCameraVms = () => {
        if (!camera.vmsUrl) return;

        const vmsTab = window.open("", "_blank");
        vmsTab.opener = null;
        axios.get(`${API_URL}/vms/access-from-video-camera/${camera.vmsId}/${camera.id}`)
            .then(({data}) => vmsTab.location.href = data)
            .catch(() => {
                vmsTab.close();
                projectUtils.swalErrorMessage("", "Não foi possível abrir o VMS.", "Ok");
            })
    }

    return (
        <div className="flex h-full min-h-0 flex-col">
            <div className="flex h-10 shrink-0 items-center border-b border-gray-300 px-4 font-semibold text-[#676a6c]">Câmera VMS</div>

            <div className="relative min-h-0 flex-1 overflow-y-auto px-4 py-3">
                <div className={"mb-3"}>
                    <h3 className="text-[18px]! break-words font-semibold inner-link mb-2" onClick={() => openCameraVms()}>
                        {camera.id} - {camera.name}
                    </h3>
                    <div className="break-words text-sm text-gray-500">{camera.vmsName || camera.vmsUrl}</div>
                    <div className="text-sm text-gray-500">Distância: {camera.distanceMeters} m</div>
                </div>
                <div className={"flex gap-6 mb-7"}>
                    <InputSwitch
                        id="cftvAssociationSwitch"
                        label="Associar câmera"
                        checked={!!integration}
                        onChange={toggleAssociation}
                    />
                    <InputForm
                        id="cftvCorrectionMap"
                        label="Correção (s)"
                        type="number"
                        value={offset}
                        classNameWrapper={"w-[100px]!"}
                        disabled={!integration}
                        onChange={({target}) => updateOffset(target.value)}
                    />
                </div>

                {preview.data && (
                    <div className="min-h-44 shrink-0 overflow-hidden rounded bg-black">
                        <VmsPlayer camera={preview.data}/>
                    </div>
                )}
                {preview.isError && <div className="text-sm text-red-600">Não foi possível reproduzir o vídeo desta câmera.</div>}
            </div>
        </div>
    );
};

export default CftvCameraDetails;
